import { configUrl } from "../config";

export const parseQuestions = (attemptDetails) => {
    const data = JSON.parse(attemptDetails);
    console.log(data, '-originalData')
    const questions = [];
    const testPoints = data.pointsPerQuestion ?? 0;
    const testNegative = data.negativePointsPerQuestion ?? 0;

    // Keep backend order exactly as received
    data.pools.$values.forEach(pool => {
        const poolPoints =
            pool.pointsPerQuestion && pool.pointsPerQuestion > 0
                ? pool.pointsPerQuestion
                : testPoints;

        const poolNegative =
            pool.negativePointsPerQuestion != null
                ? pool.negativePointsPerQuestion
                : testNegative;

        pool.questions.$values.forEach(q => {
            const questionPoints =
                q.points && q.points > 0 ? q.points : poolPoints;

            const questionNegative =
                q.negativePoints != null
                    ? q.negativePoints
                    : poolNegative;
            // const questionNegative =
            //     q.negativePoints && q.negativePoints < 0
            //         ? q.negativePoints
            //         : poolNegative;

            questions.push({
                code: q.code,
                id: q.id,
                sequence: q.sequence,
                type: q.type,
                options: q.options?.$values?.filter(Boolean) || [],
                answer: q.answer,
                choicesAlignment: 1,
                points: questionPoints,
                negativePoints: questionNegative,
                maxQuestionForScore: pool.maxQuestionForScore,
                questionCount: pool.questionCount,
                // 
                poolId: pool.id,
                poolText: pool.text,
                pdfUrl: `${configUrl.AssessmentServer}${pool?.questionPdf}`,
                isMandatoryToPass: false,
                poolScore: 0,
                markForReview: false,
                response: null,
                isCorrect: false,
                hintCount: 0,
                markForReviewCount: 0,
                TOC: false,
                qDuration: 0,
                noOfVisits: 1
            });
        });
    });

    return questions; //we r not sorting
    // return questions.sort((a, b) => a.sequence - b.sequence);
};